import { Observable } from 'rxjs';
import type { Catalog } from '../models/catalog.model';

/**
 * Stable domain contract for remote catalog queries.
 * Implemented by AdessoCatalogApiAdapter against the adesso-connector-api.
 */
export abstract class CatalogApiPort {
  abstract getCatalogByConnectorAddress(url: string, cpId: string): Observable<Catalog>;
}
